const apiUrl = process.env.VUE_APP_API_BASE_URL
export const urlFull = (endpoint) => `${apiUrl ? apiUrl : 'https://nacional.placasysm.org/api'}${endpoint}`
